// Fallback default model when remote settings don't specify ai_editor.default_model_id.
export const AI_EDITOR_DEFAULT_MODEL_ID = 'gemini-2.5-flash-image';

// Maps any legacy/UI model id onto a valid @picsart/ai-sdk catalog id. Resolve ONLY at the SDK
// boundary (generate / getCredits / getModel); UI and selection logic keep the original id.
// Add entries here if the remote whitelist ever drifts from the SDK catalog ids.
export const MODEL_ID_ALIASES: Record<string, string> = {};

export const resolveModelId = (id: string): string => MODEL_ID_ALIASES[id] ?? id;

// Gen AI Terms of Use (shown in the footer). Matches the standalone AI Image Editor miniapp.
export const TERMS_AND_CONDITIONS_LINK = 'https://picsart.com/genaitermsofuse';
export const TERMS_AND_CONDITIONS_START_TEXT = 'By continuing, you agree to our';
export const TERMS_AND_CONDITIONS_LINK_TEXT = 'Gen AI ToU';

// Maps remote ai_editor.models icon names to design-system model icons.
export const MODEL_ICON_NAMES = {
  GEMINI: 'gemini',
  FLUX: 'flux',
  GPT: 'gpt',
  IDEOGRAM: 'ideogram',
  QWEN: 'qwen',
  RUNWAY: 'runway',
  BYTEDANCE: 'bytedance',
  GROK: 'grok',
  DEEPMIND: 'deepmind',
} as const;
